import React, { useEffect } from 'react';
import './EmsContainer.css';

const BulbBlock = () => {
	const bulbsCount = 18;
	let bulbs: any[] = new Array(bulbsCount);

	for(var i = 0; i < bulbsCount; i++){
		bulbs[i] = i;
	}

	const bulbsBlock = bulbs.map((index) =>
		<span key={index.toString()} className="bulb"></span>
	);
	return (<>{bulbsBlock}</>);
};


const LightBlock = ((props : any) => {
	return (
		<div className={props.classList}>
			<div className="inner-light"></div>
			<BulbBlock/>
		</div>
	);
});

const EmsContainer = (obj: any) => {
	return (
		<div className="ems-background">
		<div className="ems-container">
			<h1>Good Job! Emergency Services Have Arrived.</h1>
			<br/>
			<div className="lightbar">
				<LightBlock classList={'light strobe blue'}/>
				<LightBlock classList={'light strobe blue'}/>
				<LightBlock classList={'light spotlight'}/>
				<LightBlock classList={'light spotlight'}/>
				<LightBlock classList={'light strobe red delay'}/>
				<LightBlock classList={'light strobe red delay'}/>
			</div>
		</div>
		</div>
	);
};

export default EmsContainer;
